import { formatRiskDecimal } from '@/utils';
import { Badge, BadgeProps, Text } from '@cmpsr/components';

type AverageImpactBadgeProps = BadgeProps & {
  impact: number;
};

export default function AverageImpactBadge({ impact, ...props }: AverageImpactBadgeProps) {
  return (
    <Badge w="max-content" backgroundColor="alert-warning-default" py="2px" {...props}>
      <Text color="text-warning" variant="text-body-bold">
        {formatRiskDecimal(impact)}
      </Text>
    </Badge>
  );
}
